'use client'

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle
} from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { LoginDialog } from './login-dialog'
import type { ReactNode } from 'react'

type SignInPromptProps = {
  title: string
  description: string
  icon?: ReactNode
  buttonText?: string
}

export function SignInPrompt({
  title,
  description,
  icon,
  buttonText = 'Sign in'
}: SignInPromptProps) {
  return (
    <Card>
      <CardHeader className="text-center">
        {icon && (
          <div className="bg-muted mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full">
            {icon}
          </div>
        )}
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex justify-center">
          <LoginDialog>
            <Button>{buttonText}</Button>
          </LoginDialog>
        </div>
      </CardContent>
    </Card>
  )
}
